package one.healthium.profile.ui.food.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.components.AppIcons
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_13
import org.jetbrains.compose.resources.painterResource
import androidx.compose.ui.tooling.preview.Preview

@Composable
internal fun DetailsRow(
    modifier: Modifier = Modifier,
    title: String,
    value: String,
    onClick: (() -> Unit),
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 12.dp)
            .clip(AppTheme.shapes.small)
            .clickable(onClick = onClick)
            .background(gray_13, AppTheme.shapes.small)
            .padding(12.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Text(
            modifier = Modifier.weight(1f),
            text = title,
            style = AppTheme.textStyles.secondary_16_400,
            color = AppTheme.colors.text100,
        )
        Text(
            text = value,
            style = AppTheme.textStyles.secondary_16_500,
            color = AppTheme.colors.text100,
        )
        Spacer(Modifier.width(6.dp))
        Image(
            modifier = Modifier.size(width = 8.dp, height = 13.dp),
            painter = painterResource(AppIcons.icArrowRight),
            contentDescription = null,
        )
    }
}

@Composable
@Preview
private fun DetailsRowPreview() {
    AppTheme {
        DetailsRow(
            title = "Protein",
            value = "20g",
            onClick = {}
        )
    }
}